import React from 'react';
import styled, { css } from 'styled-components';
import { spinAnimation } from 'js/config/style';

const absoluteStyle = css`
  && {
    position: absolute;
    top: 0;
    right: 0;
  }
`;

const Image = styled.img`
  ${spinAnimation};
  ${({ absolute }) => absolute && absoluteStyle}
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  width: 70px;
  max-width: 100%;
`;

const Container = styled.div`
  padding: 1rem;
  position: relative;
`;

export default ({ absolute, ...props }) => (
  <Container {...props}>
    <Image absolute={absolute} src="/images/spinner.svg" />
  </Container>
);
